module.exports = __webpack_public_path__ + "6a5da8901244b0e0d30fd04a2c7c08d6.jpg";